// extracted by mini-css-extract-plugin
export default {"container":"style_container__+arqA","label":"style_label__ytbdu","textarea":"style_textarea__Gvjm-"};